export default {
  'booking.loadFailed': 'Failed to load tour',
  'booking.notFound': 'Tour not found',
  'booking.removed': 'The tour you are trying to book does not exist or has been removed.',
  'booking.backToTours': 'Back to Tours',
  'booking.received': 'Booking received!',
  'booking.thanks': 'Thanks for your request for {{title}}. It is now pending confirmation and a local expert will reach out to finalise the details.',
  'booking.checkStatus': 'You can check your booking status and details anytime in My Bookings.',
  'booking.logInView': 'Log in to view booking',
  'booking.viewBookings': 'View my bookings',
  'booking.exploreMore': 'Explore more tours',
  'booking.home': 'Home',
  'booking.tours': 'Tours',
  'booking.bookJourney': 'Book your journey',
  'booking.tellUs': 'Tell us a little about your trip and a local expert will take it from there.',
  'booking.noAccount': 'No account needed',
  'booking.guestNote': "You can book as a guest. If your email isn't registered yet, we'll create an account automatically so you can track your booking.",
  'booking.signIn': 'Sign in',
  'booking.ifAlreadyHave': 'if you already have one.',
  'booking.spots': '{{count}} Spots',
  'booking.usdPerPerson': 'USD / person',
  'booking.subtotal': 'Subtotal',
  'booking.total': 'Total',
  'booking.guidePrice': 'This is a guide price. The final quote depends on your dates, group size and the season, and is confirmed with a local expert before anything is booked.',
  'booking.noPayment': 'No payment is taken on this page. Licence No. 01-2641/2024/CDLQGVN-GP LHQT',
  'booking.contactDetails': 'Contact details',
  'booking.fullName': 'Full name',
  'booking.email': 'Email',
  'booking.phone': 'Phone number',
  'booking.fullAddress': 'Full address',
  'booking.namePlaceholder': 'e.g. Nguyen Van An',
  'booking.emailPlaceholder': 'you@example.com',
  'booking.phonePlaceholder': '+84 ...',
  'booking.addressPlaceholder': 'Street, city, country...',
  'booking.tripDetails': 'Trip details',
  'booking.travelDate': 'Preferred travel date',
  'booking.datesFlexible': 'Dates are flexible — a local expert will confirm exact availability with you.',
  'booking.adults': 'Adults',
  'booking.children': 'Children',
  'booking.pickupPoint': 'Pickup point',
  'booking.dropoffPoint': 'Dropoff point',
  'booking.pickupPlaceholder': 'e.g. Hanoi Old Quarter',
  'booking.dropoffPlaceholder': 'e.g. Ninh Binh',
  'booking.specialRequests': 'Special requests',
  'booking.specialPlaceholder': 'Dietary needs, accessibility, preferred pace, honeymoon extras... anything that helps us plan.',
  'booking.charCount': '{{n}}/500 characters',
  'booking.payment': 'Payment',
  'booking.paymentMethod': 'Payment method',
  'booking.bankTransfer': 'Bank Transfer',
  'booking.creditCard': 'Credit Card',
  'booking.momo': 'MoMo',
  'booking.zalopay': 'ZaloPay',
  'booking.cod': 'Cash on Delivery',
  'booking.discountCode': 'Discount code',
  'booking.discountPlaceholder': 'e.g. SUMMER10',
  'booking.apply': 'Apply',
  'booking.applied': '{{code}} applied',
  'booking.percentOff': '{{value}}% off',
  'booking.fixedOff': '${{value}} off',
  'booking.estimatedTotal': 'Estimated total',
  'booking.adultsUnit': 'adults',
  'booking.childrenUnit': 'children',
  'booking.halfPrice': 'half price',
  'booking.confirmBooking': 'Confirm booking',
  'booking.submitting': 'Submitting...',
  'booking.nothingCharged': 'Nothing is charged now. A local expert will confirm details before anything is agreed.',
  'booking.fillRequired': 'Please fill in all required fields.',
  'booking.submitFailed': 'Failed to submit booking. Please try again.',
  'booking.discountInvalid': "That discount code isn't valid.",
  'booking.discountInactive': 'This discount code is no longer active.',
  'booking.discountExpired': 'This discount code has expired.',
  'booking.discountLimit': 'This discount code has reached its usage limit.',
  'booking.discountMismatch': "This discount code isn't valid for this tour.",
  'booking.discountFailed': 'Failed to apply discount code.',
  'booking.discountNotValid': 'This discount code is not valid.',
  'booking.accountCreated': 'Your account has been created',
  'booking.accountCreatedNote': "We noticed your email wasn't registered yet, so we created an account for you to track this booking.",
  'booking.password': 'Password',
  'booking.hidePassword': 'Hide password',
  'booking.showPassword': 'Show password',
  'booking.copied': 'Copied',
  'booking.copy': 'Copy',
  'booking.changePassword': 'Change your password',
  'booking.changePasswordNote': "Set a password you'll remember so you don't have to keep the random one above.",
  'booking.passwordUpdated': "Password updated successfully. You're now signed in.",
  'booking.newPasswordPlaceholder': 'New password (min. 6 characters)',
  'booking.confirmPasswordPlaceholder': 'Confirm new password',
  'booking.updatePassword': 'Update password',
  'booking.updating': 'Updating...',
  'booking.passwordMin': 'Password must be at least 6 characters.',
  'booking.passwordMismatch': 'Passwords do not match.',
  'booking.passwordUpdateFailed': 'Failed to update password. Please try again.',
  'booking.captchaRequired': 'Please confirm you are not a robot.',
  'booking.captchaFailed': 'Security verification failed. Please try again.',
};